import { useState, useEffect, useCallback } from 'react';
import { fetchWithAuth } from '../Utils/fetchWithAuth'; 

export default function useGet(url) {
  const [fetchedData, setFetchedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadFlag, setReloadFlag] = useState(false);

  const refetch = useCallback(() => {
    setReloadFlag(f => !f);
  }, []);

  useEffect(() => {
    if (!url) return;
    const ac = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchWithAuth(url, { method: 'GET', signal: ac.signal });

        if (!response?.ok) {
          throw new Error(`Errore nella richiesta: ${response?.status}`);
        }

        const json = await response.json();
        if (!ac.signal.aborted) setFetchedData(json);
      } catch (err) {
        if (!ac.signal.aborted) setError(err);
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };

    fetchData();
    return () => ac.abort();
  }, [url, reloadFlag]);

  return { fetchedData, loading, error, refetch };
}
